import React from "react";
import PropTypes from "prop-types";
import { Search } from '@sainsburys-tech/icons'
import { Display3, SearchInput } from "@sainsburys-tech/fable";
import * as styles from "./AlertSearch.styles";
import "./AlertSearch.css";



const AlertSearch = props => (
  <div className="alert-search">
    <Display3 as="h3" style={styles.alertHeading}>Find Alert</Display3>
    <SearchInput
      label="Alert ID"
      name="alert-search"
      value={props.searchText}
      placeholder="e.g. 0687-0001"
      onChange={(value) => props.onChange(value)}
      onSubmit={() => props.onSearchClick()}
      button={{
        icon: <Search />,
        hasHiddenText: true,
        onClick: props.onSearchClick
      }}
    />
  </div>
);

AlertSearch.propTypes = {
  searchText: PropTypes.string,
  onSearchClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default AlertSearch;
